export interface IAnalyticsConfig {
  GATrackingCode: string;
  debug_activeOnDevelopment: boolean; // should be false, true means on dev will also send analytics
}

export const analyticsConfig: IAnalyticsConfig = {
  GATrackingCode: "UA-125482253-1",
  debug_activeOnDevelopment: true, // todo: set this to false
};
